import {Injectable} from '@angular/core';
import {environment} from './../../../environments/environment';
import {HttpRequestService} from './../../shared/services/http-request.service';
import {NewPasswordModel, UserModel} from './../../models/user/users.model';
import {HttpClient} from '@angular/common/http';
import { ClientModel } from '../../models/survey/survey.model';

@Injectable()
export class ClientsService {

  private getAllLicenseTierUrl = environment.apiUrl + '/Client/GetAllLicenseTier';
  private getAllUrl = environment.apiUrl + '/Client/GetAllClient';
  private saveUrl = environment.apiUrl + '/Client/Save';
  private getClientUrl = environment.apiUrl + '/Client/GetClient';
  private deleteUrl = environment.apiUrl + '/Client/Delete';
  private getCurrentClientUrl = environment.apiUrl + '/Client/GetCurrentClient';
  private getClientNameUrl = environment.apiUrl + '/Client/GetClientByName';

  constructor(private http: HttpRequestService, private httpClient: HttpClient) {
  }

  getAllLicenseTier() {
    return this.http.get(this.getAllLicenseTierUrl, false);
  }

  getAll() {
    return this.http.get(this.getAllUrl, false);
  }

  getClient(id) {
    return this.http.get(this.getClientUrl + '?id=' + id, false);
  }

  save(data: ClientModel) {
    return this.http.post(this.saveUrl, data, true, 'Save complete');
  }

  delete(id) {
    return this.http.get(this.deleteUrl + '?id=' + id, false);
  }

  getCurrentClient() {
    return this.http.get(this.getCurrentClientUrl, false);
  }

  getClientName(name, id) {
    return this.http.get(this.getClientNameUrl + '?clientName=' + name + '&clientId=' + id, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/clients/clients.service.ts